import { TProvisioningStatus } from "../services/types/users.types";
import { ICompanyProvisioningStatus } from "../services/types/onboardint.types";

export const PROVISIONING_POLL_INTERVAL_MS = 2500;

export const PROVISIONING_SUCCESS_DISPLAY_MS = 1800;

export const normalizeProvisioningStatus = (
  status: TProvisioningStatus | null | undefined
): TProvisioningStatus => {
  if (!status || status === "complete") {
    return "complete";
  }
  return status;
};

export const isNewCompanyRecord = (id?: number | null): boolean =>
  !id || id === 0;

export const shouldWaitForProvisioning = (
  isNewCompany: boolean,
  status: TProvisioningStatus | null | undefined
): boolean =>
  isNewCompany && normalizeProvisioningStatus(status) === "processing";

export const getProvisioningErrorMessage = (
  response: Pick<ICompanyProvisioningStatus, "errorMessage" | "message">
): string => response.errorMessage || response.message || "";

export const delay = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

export type FetchProvisioningStatus = (
  guid: string
) => Promise<ICompanyProvisioningStatus>;

export const pollProvisioningStatus = async (
  guid: string,
  fetchStatus: FetchProvisioningStatus,
  options?: {
    onMessageUpdate?: (message: string) => void;
    intervalMs?: number;
  }
): Promise<ICompanyProvisioningStatus> => {
  const intervalMs = options?.intervalMs ?? PROVISIONING_POLL_INTERVAL_MS;

  while (true) {
    await delay(intervalMs);

    const statusResponse = await fetchStatus(guid);
    const status = normalizeProvisioningStatus(statusResponse.provisioningStatus);

    if (statusResponse.message) {
      options?.onMessageUpdate?.(statusResponse.message);
    }

    if (status === "complete") {
      return statusResponse;
    }

    if (status === "failed") {
      throw new ProvisioningFailedError(getProvisioningErrorMessage(statusResponse));
    }
  }
};

export class ProvisioningFailedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ProvisioningFailedError";
  }
}
